const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then((metrics) => {
      const {
        onCLS,
        onINP,
        onFCP,
        onLCP,
        onTTFB,
        getCLS,
        getFID,
        getFCP,
        getLCP,
        getTTFB,
      } = metrics;

      // web-vitals v5+ uses on* APIs and INP. Keep fallback for older versions.
      if (typeof onCLS === 'function') onCLS(onPerfEntry);
      else if (typeof getCLS === 'function') getCLS(onPerfEntry);

      if (typeof onINP === 'function') onINP(onPerfEntry);
      else if (typeof getFID === 'function') getFID(onPerfEntry);

      if (typeof onFCP === 'function') onFCP(onPerfEntry);
      else if (typeof getFCP === 'function') getFCP(onPerfEntry);

      if (typeof onLCP === 'function') onLCP(onPerfEntry);
      else if (typeof getLCP === 'function') getLCP(onPerfEntry);

      if (typeof onTTFB === 'function') onTTFB(onPerfEntry);
      else if (typeof getTTFB === 'function') getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
